import { paymentsConfig, createSelectOptionsForCardForm, getCardInfo } from './paymentsUtils.js';

paymentsConfig.loadSDKScript(25);

/**
 * 
 * @param {HTMLFormElement} form 
 * @returns {Promise<void>}
 */
export const submitForm = (form) => {
  return new Promise((resolve, reject) => {
    if (!PagSeguro) {
      reject("Falha ao carregar o script do mercado pago");
    }
    const { cardholderName, cardNumber, securityCode, cardExpirationMonth, cardExpirationYear } = getCardInfo(form);
    if (
      !cardholderName || !cardNumber || !securityCode || !cardExpirationMonth || !cardExpirationYear
    ) {
      reject("É preciso preencher todas as informações do cartão.");
    }
    const card = PagSeguro.encryptCard({
			publicKey: paymentsConfig.getByGateway(25).sdk_public_key,
      holder: cardholderName,
      number: cardNumber,
      expMonth: cardExpirationMonth,
      expYear: cardExpirationYear,
      securityCode,
    });
		const encrypted = card.encryptedCard;
    const tokenInput = document.createElement("input");
    tokenInput.type = 'hidden';
    tokenInput.name = "token";
    tokenInput.value = encrypted;
    form.appendChild(tokenInput);
    resolve();
  });
} 
